import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {NavBaseComponent} from '../nav-base/nav-base.component';
import {FiltersService} from "../../search/search-list/filters/filters.service";

@Component({
  selector: 'app-nav-browse',
  templateUrl: './nav-browse.component.html',
  styleUrls: ['../nav-base/nav-base.component.scss']
})
export class NavBrowseComponent extends NavBaseComponent{

  constructor(private router: Router, private filtersService: FiltersService){
    super();
  }

  navigateToBrowse() {
    this.router.navigate(['/search/b/'], { queryParams: {filters: '_type:-work'}});
  }

}
